import { Card } from "../../../components/ui/card";

import ProfileImage from "../../../components/profile/profile-image";
import ProfileDetails from "../../../components/profile/profile-details";
import PatientLoginHistory from "./patientLoginHistory";
import { Edit, Edit2, Edit3, X } from "lucide-react";
import { useState } from "react";

const Profile = () => {
  const [editProfileClicked, setEditProfileClicked] = useState(false);
  return (
    <div className="p-2">
      <div className="text-2xl flex justify-between md:text-3xl text-gray-900 font-semibold mb-6 md:mb-8">
        My Profile
        <button
          onClick={() => setEditProfileClicked(!editProfileClicked)}
          className={`text-xl py-2 px-3 rounded-lg border  ${editProfileClicked ? "border-red-700 text-red-700" : "text-blue-700 border-blue-700"} flex items-center gap-4`}
        >
          {editProfileClicked ? <X /> : <Edit3 className="" />}
          {editProfileClicked ? "Cancel" : "Edit Profile"}
        </button>
      </div>
      {editProfileClicked && (
        <Card className="md:flex w-full">
          <ProfileImage />
          <ProfileDetails />
        </Card>
      )}

      <PatientLoginHistory />
    </div>
  );
};

export default Profile;
